const aboutES = {
	title: "Sobre Sin Fila",

	/* Etiquetas cortas en mayúsculas sobre cada encabezado */
	eyebrows: {
		mission: "Nuestra Misión",
		founder: "El Fundador",
		pillars: "Para Quién Es",
		vision: "Lo Que Viene",
		join: "Comienza Hoy",
	},

	hero: {
		tagline: "Una empresa dominicana, creada para negocios dominicanos.",
		intro: "Sin Fila nació con una misión: ayudar a los negocios dominicanos a modernizar la forma en que gestionan sus citas y hacer crecer sus negocios. Estamos orgullosamente registrados en la República Dominicana y comprometidos con apoyar a los emprendedores locales con una tecnología diseñada alrededor de las realidades de hacer negocios aquí.",
		founder: "Detrás de Sin Fila hay un fundador dominicano con más de 10 años de experiencia desarrollando productos digitales y liderando iniciativas tecnológicas para organizaciones Fortune 500. Esa experiencia global ha sido traída de vuelta a la República Dominicana para crear una plataforma simple, confiable y diseñada específicamente para las necesidades del mercado dominicano.",
		founderMeta: "Fundador dominicano · Más de 10 años creando productos digitales",
		vision: "Nuestra visión es convertirnos en el socio tecnológico de confianza para miles de negocios dominicanos, ayudándolos a crecer, atender más clientes y avanzar hacia el futuro con confianza.",
		flag: "Orgullosamente creada y registrada en la República Dominicana",
		primaryCta: "Publica tu negocio",
		secondaryCta: "Explorar negocios",
		/* Panel de identidad junto al texto del hero — cada fila repite un dato del texto anterior. */
		identity: [
			{ label: "Sede", value: "República Dominicana" },
			{ label: "Empresa", value: "Registrada en RD" },
			{ label: "Construida con", value: "React + AWS" },
		],
	},

	whoWeAre: {
		title: "Quiénes Somos",
		text: "Sin Fila es una plataforma moderna creada para simplificar la manera en que las personas reservan citas con profesionales de servicios. Sin esperas, sin confusiones y sin mensajes innecesarios. Nuestro objetivo es hacer que la experiencia de agendar sea fluida tanto para clientes como para negocios.",
	},

	pillars: {
		title: "Creada para ambos lados de la cita",
		subtitle: "Una sola plataforma que funciona igual de bien para quien reserva como para el negocio que recibe la reserva.",
	},

	clients: {
		title: "Para Clientes",
		label: "Clientes",
		text: "Encuentra y reserva fácilmente con profesionales de confianza en distintas industrias. Consulta disponibilidad en tiempo real, elige tu hora preferida, recibe recordatorios automáticos y administra todo desde tu teléfono. Rápido, sencillo y conveniente.",
	},

	staff: {
		title: "Para Profesionales y Dueños de Negocios",
		label: "Negocios",
		text: "Administra tu agenda, reduce ausencias y haz crecer tu negocio con herramientas para citas, servicios, personal, pagos y comunicación con clientes. Sin Fila ayuda a mantener tu operación organizada, automatizada y eficiente.",
	},

	tech: {
		title: "Tecnología y Confiabilidad",
		label: "Plataforma",
		text: "Construido con tecnologías modernas como React y AWS, Sin Fila está diseñado para ser rápido, seguro y escalable. Priorizamos la estabilidad y la confiabilidad para que puedas usar la plataforma todos los días con total confianza.",
	},

	future: {
		title: "Visión Futura",
		text: "Seguimos mejorando y preparándonos para lanzar aplicaciones móviles completas, nuevas funciones avanzadas y soporte para más industrias y regiones. Esto es solo el comienzo.",
		roadmap: [
			{
				title: "Apps móviles nativas",
				desc: "Aplicaciones completas para iOS y Android para que clientes y negocios lo gestionen todo desde el teléfono.",
			},
			{
				title: "Más categorías",
				desc: "Ampliando más allá de nuestras primeras industrias hacia todo tipo de negocio que trabaje con citas.",
			},
			{
				title: "Herramientas avanzadas",
				desc: "Más reportes, marketing y automatización para negocios de todos los tamaños.",
			},
		],
	},

	joinUs: {
		title: "Únete a Nosotros",
		text: "Ya seas cliente en busca de profesionales o un negocio que quiere organizarse mejor, Sin Fila está aquí para facilitarte la vida. Comienza hoy y descubre una forma más inteligente de reservar.",
	},
};

export default aboutES;
